// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body.FullScreenRoute--open #intercom-container,\nbody.FullScreenRoute--open .intercom-lightweight-app {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
